var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardiovascularHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 87,
    viewBox: "0 0 96 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8374_33790)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8374_33790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08439 66.5399C-1.94348 56.1941 1.04988 40.7436 10.4003 33.6202C15.0155 30.1039 20.8102 28.7219 25.6688 25.629C31.2269 22.0918 35.5815 16.9276 39.7613 11.8824C48.2545 1.63112 57.8174 -1.9516 71.0355 1.00484C82.8615 3.64989 91.1799 11.683 93.9195 23.7467C99.457 48.112 96.2442 72.0014 71.471 82.8615C60.1079 87.8438 43.8724 87.4694 31.9264 84.359C23.1178 82.0638 8.90188 74.8179 4.08096 66.5399",
    fill: "#FECEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4248 80.6576C47.4248 80.6576 77.8018 62.2132 77.8018 44.8799C77.8018 36.0339 70.681 28.7585 61.8968 28.7585C55.4667 28.7585 49.9336 32.6278 47.4248 38.1897C44.916 32.6278 39.383 28.7585 32.9529 28.7585C24.1687 28.7585 17.0479 36.0304 17.0479 44.8799C17.0479 62.2098 47.4248 80.6576 47.4248 80.6576Z",
    fill: "#EF5489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4516 70.2931C47.3956 70.2931 47.3362 70.2897 47.2802 70.2792C46.8483 70.2026 46.5022 69.8543 46.4132 69.4016L41.6695 45.472L37.1038 64.6825C36.9983 65.1283 36.6456 65.4592 36.217 65.5219C35.7885 65.5845 35.3632 65.3617 35.149 64.9611L30.0954 55.5161L25.4044 59.7754C25.2132 59.9496 24.966 60.0471 24.7121 60.0471H1.58063C1.41933 59.3247 1.51081 59.8245 1.38709 59.1581C1.25282 57.8036 0.753062 57.637 2.03762 57.637L24.3165 57.8042L29.6899 52.925C29.9305 52.7056 30.2536 52.6115 30.5668 52.6707C30.8799 52.7299 31.1502 52.9319 31.3085 53.2245L35.6896 61.4158L40.7333 40.1992C40.8552 39.6942 41.2871 39.346 41.7849 39.3495C42.2793 39.3599 42.7013 39.7291 42.8035 40.241L47.9296 66.1L52.2283 58.3649C52.4195 58.0201 52.7689 57.8112 53.1447 57.8112H58.3763L63.753 51.8035C63.954 51.5807 64.2309 51.4518 64.5243 51.4518C64.8144 51.4518 65.0946 51.5772 65.2957 51.8035L70.6723 57.8042H93.9656C94.3661 57.8042 94.0889 58.2432 93.8672 58.9714C93.5535 59.8055 93.585 60.0471 93.3789 60.0471H70.2141C69.924 60.0471 69.6438 59.9217 69.4427 59.6953L64.5243 54.2066L59.6059 59.7023C59.4048 59.9252 59.1246 60.054 58.8345 60.054H53.7513L48.3713 69.7359C48.1801 70.0842 47.8274 70.2897 47.4549 70.2897",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8374_33790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 87,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8374_33790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.8103,
    height: 87.7421,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiovascularHealth);
export default __webpack_public_path__ + "static/media/CardiovascularHealth.e1f984a3acdf931c99561391f9dff1f2.svg";
export { ForwardRef as ReactComponent };